// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ld-1";
export var messageSideRight = "_ld-2";
export var subscribeToBackInStockBubbleContainer = "_ld-0";